/* Le menu du haut de l'apprenant est-il masque ?

   Deux raisons de le masquer : l'ecran (lecteur de module, icebreaker, scan)
   et l'onboarding pas termine (L71 : sexe, poste, naissance, departement).

   ⚠️ Fiche de Nawal du 06/10/2026, C9 : l'onboarding etait juge sur le profil
   GARDE DANS LE NAVIGATEUR (localStorage, ecrit a la connexion). Un profil
   complete depuis restait « incomplet » la : le menu restait masque jusqu'a
   une deconnexion. Des que le serveur a repondu, on juge sur SON profil
   (`isOnboarded`, meme regle cote serveur) ; avant, sur le profil garde, pour
   ne pas faire clignoter le menu pendant l'onboarding. */
const profilIncomplet = (u) =>
  u?.sexe === null || u?.poste === null || u?.naissance === null || u?.departement === null

export const navbarMasquee = ({ masqueParEcran, profilServeur, profilGarde }) => {
  if (masqueParEcran) return true
  if (profilServeur) return profilServeur.isOnboarded !== true
  return profilIncomplet(profilGarde)
}

export const masqueParEcran = (chemin) =>
  chemin === '/formation' || chemin === '/icebreaker' || !!chemin?.includes('/thescan/')
